/* eslint-disable no-undef */
export default {
	name: "password-generator",
	// props: ["userId", "username"],
	props: ["regeneratePassword", "reset"],
	emits: ["passwordGenerated"],
	data() {
		return {
			idForModal: null,
			password: null,
			passwordGenerator:{
				length: 8,
				lowercaseCharacters: true,
				uppercaseCharacters: true,
				numbers: true,
				symbols: true,
				excludeSimilarCharacters: true,
				excludeAmbiguousCharacters: true
			},
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false
		};
	},
	methods: {
		generatePassword(){
			var request = {
				length: this.passwordGenerator.length,
				useLowercaseLetters: this.passwordGenerator.lowercaseCharacters,
				useUppercaseLetters: this.passwordGenerator.uppercaseCharacters,
				useNumbers: this.passwordGenerator.numbers,
				useSymbols: this.passwordGenerator.symbols,
				excludeSimilarCharacters: this.passwordGenerator.excludeSimilarCharacters,
				excludeAmbiguousCharacters: this.passwordGenerator.excludeAmbiguousCharacters
			};
			securityService.generatePassword(request).then(
				successResponse => {
					var isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						this.password = successResponse.data.password;
						this.$emit("passwordGenerated", this.password);
					}
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onNumbersForPasswordChange(){
			this.generatePassword();
		},
		onPasswordLengthChange(){
			if(this.passwordGenerator.length < 8){
				this.passwordGenerator.length = 8;
			}
			this.generatePassword();
		},
		onLowercaseLettersForPasswordChange(){
			this.generatePassword();
		},
		onUppercaseLettersForPasswordChange(){
			this.generatePassword();
		},
		onSymbolsForPasswordChange(){
			this.generatePassword();
		},
		onExcludeSimilarCharactersForPasswordChange(){
			this.generatePassword();
		},
		onExcludeAmbiguousCharactersForPasswordChange(){
			this.generatePassword();
		}
	},
	computed: {
        
	},
	mounted: function () {
		this.generatePassword();
	},
	unmounted: function() {
		console.log("unmounted");
		
	},
	watch: {
		regeneratePassword: {
			handler: function () {
				if(this.regeneratePassword){
					this.generatePassword();
				}
			},
			immediate: true,
			deep: true
		},
		reset: {
			handler: function () {
				if(this.reset){
					this.passwordGenerator ={
						length: 8,
						lowercaseCharacters: true,
						uppercaseCharacters: true,
						numbers: true,
						symbols: true,
						excludeSimilarCharacters: true,
						excludeAmbiguousCharacters: true
					};
				}
			},
			immediate: true,
			deep: true
		}
	}
};